import { render, staticRenderFns } from "./LedgerOrderList.vue?vue&type=template&id=3736bbab&"
import script from "./LedgerOrderList.vue?vue&type=script&lang=js&"
export * from "./LedgerOrderList.vue?vue&type=script&lang=js&"
import style0 from "./LedgerOrderList.vue?vue&type=style&index=0&id=3736bbab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports